import React from 'react'
import { Skeleton, } from "@mui/material";
import { generateWidthByscreenSize, isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper'
import './CartSkeleton.scss'




function CartSkeleton() {
    return (

        <div className='empty-cart-skeleton-container'>
            <div>
                <div className='text-empty-skeleton'>
                    Empty cart</div>
                <Skeleton variant="circular" width={180} height={180} />
                <Skeleton variant="text" sx={{ height: '25px', width: '180px', marginTop: '20px' }} animation="wave" />
            </div>

        </div>
    )
}

export default CartSkeleton